import { render, staticRenderFns } from "./errorDetail.vue?vue&type=template&id=3e12ba1b&"
import script from "./errorDetail.vue?vue&type=script&lang=js&"
export * from "./errorDetail.vue?vue&type=script&lang=js&"
import style0 from "./errorDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports